<template lang="html">
  <div>
    <!-- <v-flex xs12 mb-4 v-if="section.textPre" v-html="_templateLiteralString(section.textPre)"></v-flex> -->
    <v-flex
      v-if="section.textPre"
      xs12
      mb-4
      v-html="section.textPre"
    />
    <v-flex
      v-for="(reduction , i) in reductions"
      :key="reduction.type"
      xs12
      mb-4
    >
      <v-flex
        v-if="reductions.length > 1"
        pa-0
        pb-3
        class="subtitle-2"
      >
        {{ typeText[reduction.type] }}
      </v-flex>
      <v-layout wrap>
        <v-flex xs12>
          <v-layout>
            <v-flex xs12>
              Surcharge debt reduction (pa)
            </v-flex>
            <v-flex
              shrink
              class=""
            >
              {{ _$(reduction.reduction_surcharge) }}
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout>
            <v-flex xs12>
              Division 293 debt reduction (pa)
            </v-flex>
            <v-flex
              shrink
              class=""
            >
              {{ _$(reduction.reduction_div_293) }}
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout>
            <v-flex
              xs12
              class="font-weight-bold"
            >
              Total deduction (pa)
            </v-flex>
            <v-flex
              shrink
              class="font-weight-bold"
            >
              {{ _$(reduction.reduction_total) }}
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="reductions.length > 1 && i < reductions.length - 1"
        align-center
        ma-0
        my-2
      >
        <v-divider />
        <v-flex
          shrink
          px-3
          class="subtitle-2"
        >
          OR
        </v-flex>
        <v-divider />
      </v-layout>
    </v-flex>
    <!-- <v-flex xs12 v-if="section.textPost" v-html="_templateLiteralString(section.textPost)"></v-flex> -->
    <v-flex
      v-if="section.textPost"
      xs12
      v-html="section.textPost"
    />
  </div>
</template>

<script>
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    data: Object,
    section: Object
  },
  data () {
    return {

    }
  },
  computed: {
    report () {
      return this.data.report || {}
    },
    reductions () {
      return this.report.reductions || []
    },
    typeText () {
      return {
        indexed: 'INDEXED - If paid from indexed pension',
        not_indexed: 'NON-INDEXED - If paid from non-indexed pension'
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>

</style>
